import { LocationHero } from '@okam/brand-ui'
import { useHtml2React } from '@okam/html2react/provider'
import { useTranslation, Trans } from 'next-i18next'
import tw from 'twin.macro'
import { MainLayout } from 'components/layout'
import type { TDirectusProps } from 'components/layout/MainLayout'
import Seo from 'components/Seo'
import LinkHeroImg from 'components/where-to-find-us'
import { useFragment } from 'gql'
import type { SeoContentFragment } from 'gql/graphql'
import { trackImportantClick } from 'gtm-analytics/tracking'
import { useWhereToFindUs } from 'lib/react-query'
import { StoreRocket } from 'lib/store-rocket'
import { colorSchemeFragment } from 'query/single-page/fragment'

export interface TWhereToFindUs {
  locale: string
  seo: { seo: SeoContentFragment | null | undefined; pageTitle: string }
  directusProps: TDirectusProps
}

const WhereToFindUsPage = ({ locale, seo, directusProps }: TWhereToFindUs) => {
  const { data: pageData, isSuccess } = useWhereToFindUs(locale)
  const { t } = useTranslation('common')
  const { parseHTMLToReact } = useHtml2React()

  const pageColors = useFragment(colorSchemeFragment, pageData?.colorScheme)
  const pageTitle = pageData?.translations?.[0]?.title

  return (
    <>
      <Seo directusData={directusProps} seo={seo?.seo} pageTitle={seo?.pageTitle} />
      <MainLayout footerProps={directusProps} logoColor={pageColors?.accent}>
        {isSuccess && (
          <div css={pageColors?.background ? [`background-color: ${pageColors?.background}`] : tw`bg-primary-2`}>
            <LocationHero
              title={
                pageTitle ? (
                  parseHTMLToReact(pageTitle)
                ) : (
                  <Trans i18nKey={t('LOCATIONSTORE.TITLE')} components={{ bold: <strong /> }} />
                )
              }
              subtitle={
                pageData?.translations?.[0]?.heading ?? (
                  <Trans i18nKey={t('LOCATIONSTORE.SUBTITLE')} components={{ bold: <strong /> }} />
                )
              }
            >
              <LinkHeroImg
                onTileClick={(text, textFr, link) => {
                  trackImportantClick({
                    click_type: 'tuile',
                    interaction_location: 'page',
                    link_url: link,
                    link_text: text,
                    link_text_fr: textFr,
                  })
                }}
              />
            </LocationHero>
            <StoreRocket
              accountId={directusProps?.settings?.storeRocketAccountId ?? undefined}
              lang={locale}
              filters={directusProps?.settings?.storeRocketFilters ?? undefined}
              filtersEnabled={directusProps?.settings?.storeRocketEnabledFilters ?? undefined}
            />
          </div>
        )}
      </MainLayout>
    </>
  )
}

export default WhereToFindUsPage
